import { cn } from "@/lib/utils";

interface BrandMarkProps {
  className?: string;
  size?: number;
}

export function BrandMark({ className, size = 28 }: BrandMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      role="img"
      aria-label="gatetard"
      className={cn("text-foreground", className)}
    >
      <mask id="bm-t-cut" maskUnits="userSpaceOnUse">
        <rect width="64" height="64" fill="#fff" />
        <path
          d="M29 18 V48 a4 4 0 0 0 4 4 h4"
          stroke="#000"
          strokeWidth="4.5"
          strokeLinecap="square"
          strokeLinejoin="miter"
          fill="none"
        />
        <line
          x1="22"
          y1="26"
          x2="40"
          y2="26"
          stroke="#000"
          strokeWidth="4.5"
          strokeLinecap="square"
        />
      </mask>
      <rect width="64" height="64" rx="14" fill="currentColor" mask="url(#bm-t-cut)" />
    </svg>
  );
}
